import React from 'react';

interface NumberFieldProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  isEditing: boolean;
  formatter: (value: number) => string;
  inputWidth?: string;
  step?: string;
}

export const NumberField: React.FC<NumberFieldProps> = ({
  label,
  value,
  onChange,
  isEditing,
  formatter,
  inputWidth = 'w-24',
  step = '0.01',
}) => {
  return (
    <div className='flex justify-between items-center'>
      <span className='text-gray-600'>{label}:</span>
      {isEditing ? (
        <input
          type='number'
          step={step}
          value={value}
          onChange={(e) => onChange(parseFloat(e.target.value) || 0)}
          className={`text-xs px-2 py-1 border border-gray-300 rounded ${inputWidth}`}
        />
      ) : (
        <span className='font-medium text-gray-800'>{formatter(value)}</span>
      )}
    </div>
  );
};
